<template>
  <LineChart
    :options="computedChartOptions"
    :data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :width="width"
    :height="height"
    data-test-name="line-chart"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Line as LineChart } from 'vue-chartjs'
import * as ChartJS from 'chart.js'
import { cloneDeep, merge } from 'lodash-unified'
import { getChartDefaultOptions } from './utils'
import type { PropType } from 'vue'
import type { ChartData, ChartOptions, Plugin } from 'chart.js'

const {
  CategoryScale,
  Chart,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} = ChartJS
Chart.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
)

defineOptions({ name: 'BLineChart' })

const props = defineProps({
  chartId: {
    type: String,
    default: 'line-chart',
  },
  datasetIdKey: {
    type: String,
    default: 'label',
  },
  width: {
    type: Number,
    default: 480,
  },
  height: {
    type: Number,
    default: 240,
  },
  plugins: {
    type: Array as PropType<Plugin<'line'>[]>,
    default: () => [],
  },
  chartData: {
    type: Object as PropType<ChartData<'line', number[], unknown>>,
    default: () => ({ datasets: [] }),
  },
  chartOptions: {
    type: Object as PropType<ChartOptions<'line'>>,
    default: () => ({ responsive: true, maintainAspectRatio: true }),
  },
})

const defaultOptions = cloneDeep(
  getChartDefaultOptions('line')
) as ChartOptions<'line'>

const computedChartOptions = computed(() =>
  merge(defaultOptions, props.chartOptions)
)
</script>
